import React, { useState } from 'react';
import { Button, Checkbox, Header, Icon, Label, List, Segment } from 'semantic-ui-react';
import { RECOMMENDATION_TIER_LABELS } from '../constants';

const ConfirmSetup = ({ business_name, recommendations, isApprovedInitially = false, onBack, onConfirm }) => {
    const [isApproved, setIsApproved] = useState(isApprovedInitially);

    return (
        <Segment>
            <Header as='h3'>
                Confirm Your Business Setup
                <Header.Subheader>Review the setup for <b>{business_name}</b>. These selections are saved as a draft and won't change your account until launch.</Header.Subheader>
            </Header>
            <List divided relaxed>
                {recommendations.map(({ id, title, summary, tier }) => (
                    <List.Item key={id}>
                        <List.Icon name='check circle' color='green' />
                        <List.Content>
                            <List.Header>
                                {title} {RECOMMENDATION_TIER_LABELS[tier] && (
                                    <Label size='mini' basic color={RECOMMENDATION_TIER_LABELS[tier].color}>{RECOMMENDATION_TIER_LABELS[tier].text}</Label>
                                )}
                            </List.Header>
                            <List.Description>{summary}</List.Description>
                        </List.Content>
                    </List.Item>
                ))}
            </List>
            <Segment secondary>
                <Checkbox
                    checked={isApproved}
                    onChange={(_, { checked }) => setIsApproved(checked)}
                    label="I've reviewed these recommendations and approve them as my configuration draft"
                />
            </Segment>
            <Button basic type='button' onClick={onBack}><Icon name='arrow left' /> Back</Button>
            <Button primary floated='right' type='button' disabled={!isApproved} onClick={onConfirm}>
                Continue to Team Setup <Icon name='arrow right' />
            </Button>
            <div style={{ clear: 'both' }} />
        </Segment>
    );
}

export default ConfirmSetup;
